export const isValidMessage = (event, expectedOrigin) => event.origin === expectedOrigin;